export default {"src":"/_next/static/media/vector_1.4ff281f7.svg","height":126,"width":188,"blurWidth":0,"blurHeight":0};